module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-4.e3dfc094.png";